/**
 * Resolves a 3-segment vanity campaign link — /{source}/{campaignSlug}/{term}
 * — into a first-touch UTM capture, then renders the normal landing page in
 * place. No redirect: a redirect would either strip the vanity URL from the
 * address bar before anyone sees it, or cost an extra round trip — rendering
 * in place means the link itself just works, refresh-safe.
 *
 * An unmatched/typo'd campaign slug still captures and renders normally, no
 * 404 — source/term are free-text pass-through values by design (see
 * utmTracking.js), so even a typo is meaningful attribution data, not an
 * error state.
 *
 * Route-safety: this is registered last in App.js as a fully-dynamic
 * 3-segment catch-all. react-router's own route scoring (static segments
 * outrank dynamic ones) guarantees it can never shadow an existing route —
 * see the UTM campaign attribution plan for the source-verified scoring
 * details. RESERVED_FIRST_SEGMENTS in utmTracking.js is a defensive backstop
 * on top of that guarantee, not a substitute for it.
 */
import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import NewLanding from './NewLanding';
import { captureUtmFirstTouch } from '../services/utmTracking';

const UtmLandingResolver = () => {
  const { source, campaignSlug, term } = useParams();
  const location = useLocation();

  useEffect(() => {
    captureUtmFirstTouch({ source, campaign: campaignSlug, term });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [source, campaignSlug, term, location.pathname]);

  return <NewLanding />;
};

export default UtmLandingResolver;
